import WebFontLoader from 'webfontloader';

// async load fonts
WebFontLoader.load({
  google: {
    families: ['Barlow:400,500,600,700,800,900&display=swap', 'Inter:400,500,700,900&display=swap'],
  },
});
